/*
 * @flow
 * @Author: Prasanth
 */

export const FRANCHISE_OTP_SCREEN = "/otp";
export const FRANCHISE_LOGIN_SCREEN = "/login";
